import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from 'environments/environment';

import { AuthGuard, workspacesGuardActivate } from '@keeps-platform-frontend-workspace/kp-keeps';
import { WorkspaceGuard } from './shared/guard/workspace.guard';
import { WorkspaceProfileComponent } from './main/workspace/containers';
import { ActivityLogComponent } from './main/activity-log/activity-log.component';

const routes: Routes = [
  {
    path: 'workspace/profile',
    component: WorkspaceProfileComponent,
    canActivate: [AuthGuard, WorkspaceGuard],
    data: {
      roles: ['company_admin', 'keeps_admin'],
    },
  },
  {
    path: 'workspaces',
    loadChildren: () =>
      import('@keeps-platform-frontend-workspace/workspaces').then((m) => {
        m.WorkspacesModule.moduleConfig = {
          logoUrl: environment.workspacesPageLogo,
          environment,
          isMyAccount: true,
        };
        return m.WorkspacesModule;
      }),
    data: { layout: 'empty', roles: [] },
  },
  {
    path: 'users',
    loadChildren: () => import('./main/users/users.module').then((m) => m.UsersModule),
    canActivate: [AuthGuard],
    data: {
      roles: ['keeps_admin', 'company_admin'],
    },
  },
  {
    path: 'user/profile',
    loadChildren: () =>
      import('@keeps-platform-frontend-workspace/profile').then((m) => {
        m.ProfileModule.moduleConfig = {
          keycloak: {
            url: environment.keycloakConfig.url,
            realm: environment.keycloakConfig.realm,
            clientId: environment.keycloakConfig.clientId,
          },
        };
        return m.ProfileModule;
      }),
    canLoad: [workspacesGuardActivate],
    data: {
      roles: [],
    },
  },
  {
    path: 'backoffice',
    loadChildren: () => import('./main/backoffice/backoffice.module').then((m) => m.BackofficeModule),
  },
  {
    path: 'activity-log',
    component: ActivityLogComponent,
    canActivate: [AuthGuard],
    data: {
      roles: ['keeps_admin', 'company_admin'],
    },
  },
  {
    path: '**',
    redirectTo: environment.routeHome,
    canLoad: [WorkspaceGuard, AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
